const ListSites = () => import(/* webpackChunkName: "site-group" */ '@/views/site/ListSites')

export default [
  {
    path: 'site',
    name: 'site',
    components: {
      studyContent: ListSites
    },
    meta: {
      title: '团队'
    }
  }
]
